import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EditTutorModal } from './EditTutorModal';
import EditIcon from '../../../../../svg/EditIcon';
import { CreateTutorModal } from './CreateTutorModal';
import DeleteIcon from '../../../../../svg/DeleteIcon';
import ToggleSwitch from '../../../../components/common/ToggleSwitch';
import { showSuccessToast } from '../../../../components/PluginsMenu/Toastr/Toastr';
import { ConfirmActionModal } from '../../../../components/common/Modal/ConfirmActionModal';
import {
  useCreateTutorMutation,
  useDeactivateTutorMutation,
  useDeleteTutorMutation,
  useLazyGetAllTutorsQuery,
  useReactivateTutorMutation,
  useUpdateTutorMutation,
} from '../../../../../store/services/admin/UserService';
import { getErrorMessage } from '../../../../../utils/utils';
import { Table } from '../../../../components/Sessions/Table';
import Pagination from '../../../../components/Dashboard/Pagination';

export const AdminTutorsListing = () => {
  const [createTutor] = useCreateTutorMutation();
  const [updateTutor] = useUpdateTutorMutation();
  const [deleteTutor] = useDeleteTutorMutation();
  const [triggerGetAllTutors, { data, isLoading }] = useLazyGetAllTutorsQuery();
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showCreateTutorModal, setShowCreateTutorModal] = useState(false);
  const [showEditTutorModal, setShowEditTutorModal] = useState(false);
  const [selectedTutorId, setSelectedTutorId] = useState(null);
  const [selectedTutor, setSelectedTutor] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [learningLanguages, setLearningLanguages] = useState([]);

  const [tutors, setTutors] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;
  console.log(tutors);

  useEffect(() => {
    triggerGetAllTutors({ PageNumber: currentPage, take: pageSize, search: searchTerm });
  }, [currentPage, searchTerm]);

  useEffect(() => {
    if (data?.data) {
      setTutors(data.data?.tutors);
      setTotalCount(data.data.totalCount);
    }
  }, [data]);

   useEffect(() => {
      const fetchLanguages = async () => {
        try {
          const response = await fetch('https://api.nkenne.com/api/Language/GetAllLanguage');
          const data = await response.json();
          console.log(data);
          setLanguages(data);
        } catch (error) {
          console.error('Failed to fetch languages:', error);
        }
      };
      fetchLanguages();
    }, []);

    useEffect(() => {
        const fetchLearningLanguages = async () => {
          try {
            const response = await fetch('https://api.nkenne.com/api/Language/GetAllLearningLanguage');
            const data = await response.json();
            setLearningLanguages(data);
          } catch (error) {
            console.error('Failed to fetch learning languages:', error);
          }
        };
        fetchLearningLanguages();
    }, []);

  if (isLoading) return <p>Loading tutors...</p>;

  const handleTutorDelete = async () => {
    const response = await deleteTutor({ id: selectedTutorId });
    if (response?.data?.succeeded) {
      setTutors((prev) => prev.filter((tutor) => tutor.id !== selectedTutorId));
      showSuccessToast(`Tutor with id ${selectedTutorId} deleted successfully.`);
      setShowConfirmModal(false);
    } else {
      getErrorMessage(response?.error?.data?.errors[0]);
    }
  };

  const handleSaveTutor = async (createdTutor) => {
    const response = await createTutor(createdTutor);
    if (response?.data?.succeeded) {
      showSuccessToast(`Tutor ${createdTutor.Name} created successfully.`);
      setShowCreateTutorModal(false);
    } else {
      getErrorMessage(response?.error?.data?.errors[0]);
    }
  };

  const handleEditTutor = async (editedTutor) => {
    const {
      id: TutorId,
      name: Name,
      gender: Gender,
      email: Email,
      experienceLevel: ExperienceLevel,
      about: About,
      location: Location,
      dialect: Dialect,
      age: Age,
      education: Education,
      language: Language,
      timezone: Timezone,
      profileImage: ProfilePicture,
      whatsappNumber: whatsappNumber
    } = editedTutor;
  
    const response = await updateTutor({
      TutorId,
      Name,
      Gender,
      Email,
      ExperienceLevel,
      About,
      Location,
      Dialect,
      Age,
      Education,
      Language,
      Timezone,
      ProfilePicture,
      whatsappNumber
    });

    if (response?.data?.succeeded) {
      const updatedTutor = {
        ...editedTutor,
        dialect: languages.find((l) => l.id.toString() === Dialect.toString())?.name || Dialect,
        language: learningLanguages.find((l) => l.id.toString() === Language.toString())?.name || Language,
      };
      setTutors((prev) => prev.map((tutor) => (tutor.id === editedTutor.id ? updatedTutor : tutor)));
      triggerGetAllTutors({ PageNumber: currentPage, take: pageSize, search: searchTerm });
      showSuccessToast(`Tutor ${editedTutor.name} updated successfully.`);
      setShowEditTutorModal(false);
    } else {
      getErrorMessage(response?.error?.data?.errors[0]);
    }
  };

  const confirmDelete = (e, id) => {
    e.stopPropagation();
    setSelectedTutorId(id);
    setShowConfirmModal(true);
  };

  const handleEditClick = (e, tutor) => {
    e.stopPropagation();
    setSelectedTutor(tutor);
    setShowEditTutorModal(true);
  };

  const handleCreateTutor = () => setShowCreateTutorModal(true);

  const Actions = ({ id, tutor }) => (
    <div className="d-flex gap-2">
      <div onClick={(e) => confirmDelete(e, id)} className="cursor-pointer">
        <DeleteIcon fill="#ff0000" width={18} height={18} />
      </div>
      <div onClick={(e) => handleEditClick(e, tutor)} className="cursor-pointer">
        <EditIcon width={18} height={18} />
      </div> 
    </div>
  );

  const Status = ({ tutor }) => {
    const [deactivateTutor] = useDeactivateTutorMutation();
    const [reactivateTutor] = useReactivateTutorMutation();

    const handleStatusToggle = async (newStatus) => {
      
      if (newStatus) await reactivateTutor({ id: tutor.id });
      else await deactivateTutor({ id: tutor.id });
      showSuccessToast(`Visibility status for ${tutor.name} changed to ${newStatus ? 'Active' : 'Inactive'}`);
    };

    return <ToggleSwitch initialState={tutor.isActive} onToggle={handleStatusToggle} />;
  };

  const columns = [
    {header: 'Tutor ID', accessor: 'id'},
    {
      header: 'Name',
      accessor: 'name',
      render: (tutor) => (
        <span
          onClick={() => navigate(`/tutor/${tutor.id}`)}
          className="text-primary fw-semibold text-decoration-underline cursor-pointer w-auto"
        >
          {tutor.name}
        </span>
      ),
    },
    { header: 'Email', accessor: 'email' },
    { header: 'Subject', accessor: 'language' },
    {
      header: 'Visibility Status',
      accessor: 'visibility-status',
      render: (item) => <Status tutor={item} />,
    },
    {
      header: 'Actions',
      accessor: 'actions',
      render: (item) => <Actions id={item.id} tutor={item} />,
    },
  ];

  const buttonConfig = [
    { label: 'Create Tutor', variant: 'primary', onClick: handleCreateTutor },
  ];  

  return (
    <div className="bg-white">
      <div className="col-xl-12">
        <div className="page-title flex-wrap mb-0">
          <div className="input-group search-area mb-md-0 ml-3">
            <input
              type="text"
              className="form-control ps-4"
              placeholder="Search here..."
              value={searchTerm}
              onChange={(e) => {
                setCurrentPage(1);
                setSearchTerm(e.target.value);
              }}
            />
          </div>
          <div>
            {buttonConfig.map(({ label, onClick, variant }, i) => (
              <button key={i} className={`btn btn-${variant}`} onClick={onClick}>
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>

      <Table data={tutors} columns={columns} />

       <Pagination currentPage={currentPage} totalCount={totalCount}
            pageSize={pageSize} onPageChange={setCurrentPage} />

      <CreateTutorModal
        show={showCreateTutorModal}
        handleClose={() => setShowCreateTutorModal(false)}
        handleSave={handleSaveTutor}
        languages={languages}
        learningLanguages={learningLanguages}
      />

      <EditTutorModal
        show={showEditTutorModal}
        handleClose={() => setShowEditTutorModal(false)}
        tutor={selectedTutor}
        handleSave={handleEditTutor}
        languages={languages}
        learningLanguages={learningLanguages}
      />

      <ConfirmActionModal
        show={showConfirmModal}
        handleClose={() => setShowConfirmModal(false)}
        onConfirm={handleTutorDelete}
        title="Confirm Deletion"
        message="Are you sure you want to delete this tutor? This action cannot be undone."
        confirmText="Delete"
        cancelText="Cancel"
        confirmVariant="danger"
      />
    </div>
  );
};